import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { Button, Col, FormControl, Row } from 'react-bootstrap';
import _ from 'lodash';
import LargeCard from '../main/large-card';
import ValidatorFormGroup from '../main/validator-form-group';
import translate from '../translate';
import { StartPasswordReset } from '../../store/passwordResetSlice';
import { validateEmail } from '../../util/validators';

const VALIDATORS = {
    email: {
        isValid(val) {
            return !!val && validateEmail(val);
        },
    },
};

class PasswordResetRequest extends React.Component {
    static propTypes = {
        strings: PropTypes.object,
        StartPasswordReset: PropTypes.func.isRequired,
    };

    state = {
        submitted: false,
        data: {
            email: '',
        },
        _dirty: {},
        _valid: true,
    };

    _markDirty = (key) => {
        const newDirt = {};
        newDirt[key] = true;
        const newState = _.extend({}, this.state, {
            _dirty: _.extend({}, this.state._dirty, newDirt),
        });
        this.setState(newState);
    };

    _isDataValid = (data) => {
        return Object.keys(VALIDATORS).reduce(
            (sum, fieldName) =>
                sum && VALIDATORS[fieldName].isValid(data[fieldName]),
            true
        );
    };

    _persist = (field, value) => {
        this._markDirty(field);
        const data = _.extend({}, this.state.data);
        data[field] = value;
        this.setState({ data, isValid: this._isDataValid(data) });
    };

    _handleSubmit = (event) => {
        console.log('submit');
        event.preventDefault();
        if (this.state.isValid) {
            this.props.StartPasswordReset(this.state.data.email);
            this.setState({ submitted: true });
        }
    };

    render() {
        if (!this.state.submitted) {
            let form = (
                <form onSubmit={this._handleSubmit}>
                    <div className="wrap">
                        <ValidatorFormGroup
                            label={this.props.strings.email}
                            hideErrorLabel={
                                !this.state._dirty.email ||
                                VALIDATORS.email.isValid(this.state.data.email)
                            }
                            errorLabel={this.props.strings.invalidEmail}
                        >
                            <FormControl
                                type="text"
                                className="input-text-color"
                                value={this.state.data.email}
                                name="email"
                                onChange={(event) => {
                                    this._persist('email', event.target.value);
                                }}
                                required
                            />
                        </ValidatorFormGroup>

                        <div className="form-footer">
                            <Row>
                                <Col xs={6}>
                                    <Button
                                        className="btn-primary btn btn-default"
                                        type="submit"
                                    >
                                        {this.props.strings.submit}
                                    </Button>
                                </Col>
                            </Row>
                        </div>
                    </div>
                </form>
            );

            return (
                <Col xs={6} className="col-middle">
                    <LargeCard
                        title={this.props.strings.title}
                        type="card-edit"
                        description={this.props.strings.resetMessage}
                    >
                        {form}
                    </LargeCard>
                </Col>
            );
        } else {
            return (
                <Col xs={6} className="col-middle">
                    <LargeCard
                        title={this.props.strings.title}
                        type="card-edit"
                        description={
                            <div>
                                {this.props.strings.emailSentPreEmail}
                                <strong>{this.state.data.email}</strong>
                                {this.props.strings.emailSentPostEmail}
                            </div>
                        }
                    ></LargeCard>
                </Col>
            );
        }
    }
}

export default connect(() => ({}), { StartPasswordReset })(
    translate('PasswordResetRequest')(PasswordResetRequest)
);
